import { createContext, useContext } from 'react';

const ScrollableAncestorContext = createContext<HTMLElement | null>(null);

export const useScrollableAncestor = () => useContext(ScrollableAncestorContext);

export default ScrollableAncestorContext;